<template>
  <v-container fluid id="MyWorkOrders" class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        My Work Orders
        <v-btn color="primary" small class="ml-4" to="/work-orders/new"
          ><v-icon small left>add</v-icon> New</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="workOrderType('open')"
              >Open<span class="caption ml-1 grey--text"></span
            ></v-tab>
            <v-tab @click="workOrderType('closed')">Closed</v-tab>
            <v-tab @click="workOrderType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentWorkOrders"
            :loading="loadingWorkOrders"
            loading-text="Loading....please wait."
            :headers="headers"
            disable-sort
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                color="amber lighten-3"
                v-if="item.status == 'open'"
              >
                open
              </v-chip>
              <v-chip
                small
                color="red lighten-3"
                v-if="item.status == 'closed'"
              >
                closed
              </v-chip>
              <v-chip small v-if="item.status == 'cancelled'">
                cancelled
              </v-chip>
            </template>
            <template v-slot:item.orderDate="{ item }">{{
              item.orderDate.toDate() | moment("MMM Do [at] h:mma")
            }}</template>
            <template v-slot:item.dateCompleted="{ item }">{{
              item.dateCompleted | moment("MMM Do, YYYY")
            }}</template>
            <template v-slot:item.viewOrder="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                @click.stop="showTicket(item)"
                >view work order</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500">
      <work-order-ticket
        :workOrder="currentTicket"
        @close="closeTicket"
        :showClose="true"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import workOrderTicket from "@/components/workOrders/WorkOrderTicket";
export default {
  components: {
    workOrderTicket: workOrderTicket,
  },
  data() {
    return {
      type: "open",
      dialog: false,
      loadingWorkOrders: true,
      workOrders: [],
      currentTicket: null,
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite.street",
          sortable: true,
        },
        { text: "Date", value: "orderDate" },
        { text: "Completed", value: "dateCompleted" },
        { text: "Status", value: "status" },
        { text: "", value: "viewOrder", align: "right" },
      ],
    };
  },
  computed: {
    currentWorkOrders: function() {
      return this.workOrders.filter((wo) => wo.status == this.type);
    },
    ...mapState(["user"]),
  },
  async created() {
    try {
      const workOrders = await fb.db
        .collection("workOrders")
        .where("orderedBy.uid", "==", this.user.uid)
        .orderBy("orderDate", "desc")
        .limit(50)
        .get();
      this.workOrders = [];
      workOrders.forEach((u) => {
        this.workOrders.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.loadingWorkOrders = false;
    } catch (error) {
      alert(error);
      console.log(error);
      this.loadingWorkOrders = false;
    }
  },
  methods: {
    workOrderType(type) {
      this.type = type;
    },
    closeTicket() {
      this.dialog = false;
    },
    showTicket(ticket) {
      this.currentTicket = null;
      this.currentTicket = { ...ticket };
      this.dialog = true;
    },
  },
};
</script>
